module.exports = __webpack_public_path__ + "img/audioPlay.4834c6fa.png";